import { defineCustomElement } from '../chunks/vidstack-CRlI3Mh7.js';
import { MediaPlayButtonElement, MediaMuteButtonElement, MediaCaptionButtonElement, MediaPIPButtonElement, MediaFullscreenButtonElement, MediaSeekButtonElement, MediaAirPlayButtonElement, MediaLiveButtonElement, MediaVolumeSliderElement, MediaTimeSliderElement, MediaSliderPreviewElement, MediaSliderThumbnailElement, MediaSliderValueElement, MediaMenuElement, MediaMenuButtonElement, MediaMenuItemsElement, MediaMenuItemElement, MediaAudioRadioGroupElement, MediaCaptionsRadioGroupElement, MediaSpeedRadioGroupElement, MediaQualityRadioGroupElement, MediaRadioElement, MediaTimeElement, MediaThumbnailElement } from '../chunks/vidstack-DvuMxVXP.js';
import { MediaPlyrLayoutElement } from './templates/plyr-layout.js';
import { MediaPosterElement } from '../chunks/vidstack-QR8zGkwr.js';
import '../chunks/vidstack-Dfy6aedI.js';
import '../chunks/vidstack-Cpte_fRf.js';
import '../chunks/vidstack-BOTZD4tC.js';
import '../chunks/vidstack-DWQEfrPg.js';
import '@floating-ui/dom';
import '../chunks/vidstack-CP9ACpRU.js';
import '../chunks/vidstack-A9j--j6J.js';
import '../chunks/vidstack-DwhHIY5e.js';
import '../chunks/vidstack-lwuXewh7.js';
import '../chunks/vidstack-DXXgp8ue.js';
import '../chunks/vidstack-Dihypf8P.js';
import '../chunks/vidstack-C9vIqaYT.js';
import 'lit-html';
import '../chunks/vidstack-CwVSnsld.js';
import '../chunks/vidstack-7xep0lg7.js';
import 'lit-html/directives/if-defined.js';
import 'lit-html/directives/unsafe-svg.js';
import 'lit-html/async-directive.js';
import '../chunks/vidstack-CwTj4H1w.js';
import 'lit-html/directives/unsafe-html.js';
import '../chunks/vidstack-DGstw8fa.js';

defineCustomElement(MediaPlyrLayoutElement);
defineCustomElement(MediaPosterElement);
defineCustomElement(MediaPlayButtonElement);
defineCustomElement(MediaMuteButtonElement);
defineCustomElement(MediaCaptionButtonElement);
defineCustomElement(MediaPIPButtonElement);
defineCustomElement(MediaFullscreenButtonElement);
defineCustomElement(MediaSeekButtonElement);
defineCustomElement(MediaAirPlayButtonElement);
defineCustomElement(MediaLiveButtonElement);
defineCustomElement(MediaVolumeSliderElement);
defineCustomElement(MediaTimeSliderElement);
defineCustomElement(MediaSliderPreviewElement);
defineCustomElement(MediaSliderThumbnailElement);
defineCustomElement(MediaSliderValueElement);
defineCustomElement(MediaMenuElement);
defineCustomElement(MediaMenuButtonElement);
defineCustomElement(MediaMenuItemsElement);
defineCustomElement(MediaMenuItemElement);
defineCustomElement(MediaAudioRadioGroupElement);
defineCustomElement(MediaCaptionsRadioGroupElement);
defineCustomElement(MediaSpeedRadioGroupElement);
defineCustomElement(MediaQualityRadioGroupElement);
defineCustomElement(MediaRadioElement);
defineCustomElement(MediaTimeElement);
defineCustomElement(MediaThumbnailElement);
